import { coreEnrollerReport } from "./coreEnrollerReport";
import { enrollerReport } from "./enrollerReport";

export const enrollerReports = {
	enrollerReport,
	coreEnrollerReport
};
